//
//
//

import Model from "@/models/yunMobile";
export default {
  data() {
    return {
      code: ""
    };
  },
  methods: {
    onBridgeReady(_data, success, fail) {
      WeixinJSBridge.invoke(
        "getBrandWCPayRequest",
        {
          appId: _data.sub_appid, //公众号名称，由商户传入
          timeStamp: _data.timeStamp, //时间戳，自1970年以来的秒数
          nonceStr: _data.nonceStr, //随机串
          package: _data.package,
          signType: _data.signType, //微信签名方式：
          paySign: _data.paySign //微信签名
        },
        res => {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            if (success && typeof success === "function") success(res);
          } else {
            if (fail && typeof fail === "function") fail(res);
          }
        }
      );
    },
    async getCode() {
      let { data } = await Model.getCode({
        url:
          process.env.NODE_ENV == "production"
            ? location.href.replace(/\//g, ",")
            : `https:,,hsq0hboa5g7r.ngrok.xiaomiqiu123.top,xsq,web,wx,returncode,` +
              location.href.replace(/\//g, "*")
        // gsBh:
        //   this.$route.query && this.$route.query.gsbh
        //     ? this.$route.query.gsbh
        //     : JSON.parse(sessionStorage.getItem("wxPayParams")).gsBh
        //     ? JSON.parse(sessionStorage.getItem("wxPayParams")).gsBh
        //     : "",
        // xmBh:
        //   this.$route.query && this.$route.query.xmbh
        //     ? this.$route.query.xmbh
        //     : JSON.parse(sessionStorage.getItem("wxPayParams")).xmBh
        //     ? JSON.parse(sessionStorage.getItem("wxPayParams")).xmBh
        //     : ""
      });
      location.href = data;
    },
    async payByWx({ params, fail, paySuccess, payFail }) {
      let { data } = await Model.payByWx({
        ...params,
        code: this.code
      }).catch(err => {
        fail(err.response.data);
      });
      if (data.nonceStr) {
        console.log(1111);
        if (typeof WeixinJSBridge == "undefined") {
          console.log(222);
          //微信浏览器内置对象。参考微信官方文档
          if (document.addEventListener) {
            console.log(333);
            document.addEventListener(
              "WeixinJSBridgeReady",
              this.onBridgeReady(data, paySuccess, payFail),
              false
            );
          } else if (document.attachEvent) {
            console.log(444);
            document.attachEvent(
              "WeixinJSBridgeReady",
              this.onBridgeReady(data, paySuccess, payFail)
            );
            document.attachEvent(
              "onWeixinJSBridgeReady",
              this.onBridgeReady(data, paySuccess, payFail)
            );
          }
        } else {
          this.onBridgeReady(data, paySuccess, payFail);
        }
      }
    },
    async payByZfb({ params, success, fail }) {
      if (!params.OrderDesc) {
        params.OrderDesc = "支付宝支付";
      }
      let { data } = await Model.payByZfb({
        ...params
      }).catch(err => {
        fail(err.response.data);
      });
      if(data.payDataType==='ICBC_ZFB_JSAPI'){
        const param = JSON.parse(data.payData);
        AlipayJSBridge.call('tradePay', {
          tradeNO: param.tradeNO,
        }, (res) => {
          this.$router.go(-1);
          if (res.resultCode === '9000') {
            success(res);
          } else {
            fail(res);
          }
        });
      }else{
        location.href = data.QRURL;
      }
      // success(data);
    }
  },
  created() {
    if (this.$isWx) {
      if (!this.$route.query.code) {
        this.getCode();
      } else {
        this.code = this.$route.query.code;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/mobile/yunMobile/PayCommon.vue